import { alertConfirmDelete, alertWarning } from "components/Alert";
import { saveFile } from "components/FileUplaod/saveFile";
import { initFileUploadData } from "constants/fileUploadConstant";
import { paymentVoucherApiNm } from "constants/paymentVoucherConstant";
import { FOLDER_PAYMENT_VOUCHER } from "constants/serverConstant";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import { useEffect } from "react";
import { useMemo } from "react";
import { useCallback } from "react";
import { useState } from "react";
import { useContext } from "react";
import { addIdForDataGrid } from "utils";
import { initScPVData } from "./initData";

let orignalSCPVData = null
const useSubcontractPaymentVoucherDialog = ({ selectedRows, selectedId, dialogOpen, setDialogOpen, onFinish }) => {

  const { ax, msData } = useContext(GlobalStateContext);
  const [scPVData, setScPVData] = useState(initScPVData)
  const [scInvTable, setScInvTable] = useState([])
  const [fileUploadData, setFileUploadData] = useState({ ...initFileUploadData() })
  const [pvReportDialogOpen, setPVReportDialogOpen] = useState(false)

  const sumData = useMemo(() => {
    let sumOwnRcptAmnt = 0;
    let sumCusRcptAmnt = 0;
    let sumTotal = 0;
    let sumWhtPr = 0;
    let sumPayAmnt = 0;
    for (const row of scInvTable) {
      sumOwnRcptAmnt += +row.OwnRcptAmnt
      sumCusRcptAmnt += +row.CusRcptAmnt
      sumTotal += +row.Total
      sumWhtPr += +row.WhtPr
      sumPayAmnt += +row.PayAmnt
    }
    return ({
      OwnRcptAmnt: sumOwnRcptAmnt,
      CusRcptAmnt: sumCusRcptAmnt,
      Total: sumTotal,
      WhtPr: sumWhtPr,
      PayAmnt: sumPayAmnt
    })
  }, [scInvTable])

  const insertUpdateSubcontractPaymentVoucher = useCallback(async () => {


    let apiName = ""
    let postData = null
    if (selectedId === 0) {
      apiName = paymentVoucherApiNm.insertPaymentVoucherWithInvoice
      postData = {
        ...scPVData,
        ScInvIds: selectedRows.map(row => row.ScInvId)
      }
      ax.post(apiName, postData).then(async (value) => {
        if (value.data) {
          //---------------------------- Process files --------------------------------------------
          const pvId = value.data
          await saveFile({
            ax,
            alertWarning,
            fileUploadData,
            setFileUploadData,
            apiUpdateFileName: paymentVoucherApiNm.updateFileName,
            apiDeleteFile: paymentVoucherApiNm.deleteFile,
            apiAddFile: paymentVoucherApiNm.uploadFile,
            key: "PVFileId",
            refKey: "PVId",
            refValue: pvId
          })
          setDialogOpen(false)
          onFinish()
        }
      })
    } else {
      if (JSON.stringify(orignalSCPVData) !== JSON.stringify(scPVData)) {
        apiName = paymentVoucherApiNm.updatePaymentVoucherColumn
        const colValues = { ...scPVData }
        delete colValues.PVNo
        delete colValues.PVDte
        delete colValues.ModAcc
        delete colValues.ModAccId
        delete colValues.ModDte
        delete colValues.ScInvs
        delete colValues.PVId
        delete colValues.Sc
        delete colValues.Files
        postData = {
          ColValues: colValues,
          PVId: selectedId
        }
        await ax.post(apiName, postData)
      }
      await saveFile({
        ax,
        alertWarning,
        fileUploadData,
        setFileUploadData,
        apiUpdateFileName: paymentVoucherApiNm.updateFileName,
        apiDeleteFile: paymentVoucherApiNm.deleteFile,
        apiAddFile: paymentVoucherApiNm.uploadFile,
        key: "PVFileId",
        refKey: "PVId",
        refValue: selectedId
      })
      setDialogOpen(false)
      onFinish()
    }
  }, [ax, scPVData, selectedId, selectedRows, setDialogOpen, onFinish, fileUploadData])

  const deleteSubcontractPaymentVoucher = useCallback(() => {
    alertConfirmDelete(() => {
      ax.post(paymentVoucherApiNm.deletePaymentVoucher, { PVId: selectedId }).then(value => {
        if (value.data) {
          setDialogOpen(false)
          onFinish()
        }
      })
    })
  }, [ax, onFinish, selectedId, setDialogOpen])


  const handleBkAccIdChange = useCallback((e) => {
    const found = msData.bankAccounts.find(item => item.BkAccId === e.target.value)
    let bbNo = ""
    if (found) bbNo = found.LastBBNo
    setScPVData(o => {
      return { ...o, BkAccId: e.target.value, BBNo: bbNo || "" }
    })
  }, [msData])

  const generagePVNo = useCallback(() => {
    ax.post(paymentVoucherApiNm.generatePaymentVoucherNo, {}).then(value => {
      if (value.data) {
        setScPVData(o => ({ ...o, PVNo: value.data }))
      }
    })
  }, [ax])

  const handleOpenReportDialog = useCallback(() => {
   
    if(!scPVData.PayMthdId || +scPVData.PayAmnt === 0){
      alertWarning("กรุณาเลือกวิธีการชำระเงิน, ระบุจำนวนเงิน และบันทึกข้อมูลก่อน")
      return
    }
    setPVReportDialogOpen(true)
  }, [scPVData])

  const handlePayAll = useCallback(() => {
    setScPVData(o=>({...o, PayAmnt: sumData.PayAmnt }))
  }, [sumData.PayAmnt])
  useEffect(() => {
   
   
    if (dialogOpen) {
      if (selectedId === 0) {
        if (selectedRows.length > 0) {
          setScInvTable(selectedRows)
          ax.post(paymentVoucherApiNm.getPayDataFromSubcontract, { ScId: selectedRows[0].ScId }).then(value => {
            if (value.data && value.data.length > 0) {
              setScPVData(o => ({ ...o, ...value.data[0] }))
            }
          })
        }
      } else {
       
        ax.post(paymentVoucherApiNm.getPaymentVoucher, { PVId: selectedId }).then(value => {
          if (value.data && value.data.length > 0) {
            const scPVData = value.data[0]
            setScInvTable(addIdForDataGrid(scPVData.ScInvs, "ScInvId"))
            setScPVData(scPVData)
            orignalSCPVData = { ...scPVData }
            //-------------------process file-------------------------
            const serverFiles = scPVData.Files.map(item => ({
              id: item.PVFileId,
              fileNm: item.FileNm,
              pvId: selectedId,
              label: item.Label,
              oLabel: item.Label,
              isEdit: false,
              file: null,
              imgLink: `${window.location.origin}/${FOLDER_PAYMENT_VOUCHER}${item.PVId}/${item.FileNm}`,
            }))
            setFileUploadData({ ...initFileUploadData(), serverFiles })

          }
        })
      }
    } else {
      setScInvTable([])
      setScPVData(initScPVData)
      setFileUploadData({ ...initFileUploadData() })
    }
  }, [ax, selectedRows, selectedId, dialogOpen])
  return {
    state: { scPVData, scInvTable, fileUploadData, sumData, pvReportDialogOpen },
    fn: {
      insertUpdateSubcontractPaymentVoucher, deleteSubcontractPaymentVoucher, handleBkAccIdChange, handlePayAll
      , generagePVNo, setScPVData, setScInvTable, setFileUploadData, setPVReportDialogOpen, handleOpenReportDialog
    }
  }
}

export default useSubcontractPaymentVoucherDialog